export type PoolListSortKey = 'name' | 'code' | 'created_at' | 'address';
export type PoolListSortOrder = 'asc' | 'desc';

export type PoolListRow = {
  id?: number | string;
  name?: string | null;
  code?: string | null;
  created_at?: string | null;
  address?: string | null;
  location?: string | null;
  [key: string]: unknown;
};

function normalizeValue(value: unknown): string {
  return String(value ?? '').trim().toLowerCase();
}

function compareValues(a: unknown, b: unknown, order: PoolListSortOrder): number {
  const av = a == null ? '' : String(a);
  const bv = b == null ? '' : String(b);
  const result = av.localeCompare(bv, 'ko', { sensitivity: 'base' });
  return order === 'asc' ? result : -result;
}

export function filterAndSortPools<T extends PoolListRow>(
  pools: T[],
  query: string,
  sortKey: PoolListSortKey = 'name',
  sortOrder: PoolListSortOrder = 'asc'
): T[] {
  const q = normalizeValue(query);
  const filtered = q
    ? pools.filter((pool) => {
        const haystacks = [
          pool.name,
          pool.code,
          pool.created_at,
          pool.address,
          pool.location,
        ];
        return haystacks.some((value) => normalizeValue(value).includes(q));
      })
    : pools;

  return [...filtered].sort((a, b) => {
    if (sortKey === 'name') return compareValues(a.name, b.name, sortOrder);
    if (sortKey === 'code') return compareValues(a.code, b.code, sortOrder);
    if (sortKey === 'address') {
      return compareValues(a.address ?? a.location, b.address ?? b.location, sortOrder);
    }
    return compareValues(a.created_at, b.created_at, sortOrder);
  });
}
